import Navbar from '@/components/feature/Navbar';
import Footer from '@/components/feature/Footer';
import Hero from './components/Hero';
import CategorySection from './components/CategorySection';
import FeaturedArticles from './components/FeaturedArticles';
import FAQSection from './components/FAQSection';
import NewsletterSection from './components/NewsletterSection';

export default function Home() {
  const jsonLd = {
    '@context': 'https://schema.org',
    '@type': 'WebSite',
    name: '女性私密健康指南',
    url: 'https://readdy.ai',
    description: '科学、温暖、不羞耻的女性阴道健康知识平台，系统讲解生理结构、日常护理、常见问题及就医建议。',
    potentialAction: {
      '@type': 'SearchAction',
      target: 'https://readdy.ai/search?q={search_term_string}',
      'query-input': 'required name=search_term_string',
    },
  };

  return (
    <>
      <script type="application/ld+json">{JSON.stringify(jsonLd)}</script>
      <div className="min-h-screen">
        <Navbar />
        <main>
          <Hero />
          <CategorySection />
          <FeaturedArticles />
          <FAQSection />
          <NewsletterSection />
        </main>
        <Footer />
      </div>
    </>
  );
}